import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const ArrowLeft = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            fill={color}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.0322 16C9.02604 16 8.11628 15.1012 7.0105 14.0027C5.90473 12.9042 5 12.003 5 12C5 11.9892 9.02127 8 9.03209 8C9.03816 8 9.24112 8.19673 9.4831 8.43718L9.92308 8.87435L8.34442 10.4426L7.44784 11.3333H17.4786V12.6667H7.42583L8.33878 13.5736L9.9118 15.1363L9.4776 15.5682C9.23879 15.8057 9.03836 16 9.0322 16Z"
        />
    </StarryUIIcon>
);
